<template>
  <div class="circleHeight">
    <van-row type="flex" justify="space-between" class="circleTitle">
      <van-col span="10" class="nameTitle">{{cardData.name}}</van-col>
      <van-col span="14" class="buttonChange timeButton">
        <button :class="{ choose:2===time }" @click="changeTime(2)" v-if="showFlag.indexMonth">月</button>
        <button :class="{ choose:3===time }" @click="changeTime(3)" v-if="showFlag.indexYear">年</button>
        <p class="tiem-iconfont"  @click="showPopup">
          <img src="../../../../static/images/calendar.png" style="width:.21rem;height:.2rem">
        </p>
      </van-col>
    </van-row>
    <van-row type="flex" justify="space-between" class="circle" v-if="cardData.detectionShow||cardData.targetShow || quato==='06'">
        <van-col span="12" v-if="quato==='06'">
           <!-- 判断返回值是null 显示-- -->
          <p v-if="cardData.indexValue === '--'">
            <span>{{cardData.indexValue}}</span>{{cardData.unit}}
          </p>
          <p v-else>
            <span>{{cardData.indexValue}}</span>{{cardData.unit}}
          </p>
        </van-col>
        <van-col span="12" v-else>
           <!-- 判断返回值是null 显示-- -->
          <p v-if="cardData.achievementRate === '--'">
            <span>{{cardData.achievementRate}}</span>{{cardData.unit}}
          </p>
          <p v-else>
            <span>{{cardData.achievementRate}}</span>{{cardData.unit}}
          </p>
        </van-col>
        <van-col class="ratevalue-warpper" span="6" v-show="time===3" v-if="cardData.targetShow">
          <div class="ratevalue-value-second" >
            <!-- <img src="../../../../static/images/splitLine.png"> -->
          </div>
          <div class="ratevalue-value">
            <span v-if="cardData.target !== null">{{cardData.target}}{{cardData.unit}}</span>
            <span v-else>--{{cardData.target}}{{cardData.unit}}</span>
            <p>目标值</p>
          </div>
        </van-col>
        <van-col class="ratevalue-warpper" span="6" v-show="time===3" v-if="cardData.detectionShow">
          <div class="ratevalue-value-second">
            <!-- <img src="../../../../static/images/splitLine.png"> -->
          </div>
          <div class="ratevalue-value">
            <span v-if="cardData.detection !== null">{{cardData.detection}}{{cardData.unit}}</span>
            <span v-else>--{{cardData.detection}}{{cardData.unit}}</span>
            <p>监测值</p>
          </div>
        </van-col>
    </van-row>
    <van-row type="flex"  justify="center" class="circle"  v-else>
      <van-col span="16">
           <!-- 判断返回值是null 显示-- -->
          <p v-if="cardData.indexValue === '--'" style="text-align:center">
            {{cardData.achievementRateName}}<span>{{cardData.achievementRate}}</span>{{cardData.unit}}
          </p>
          <p v-else style="text-align:center">
            {{cardData.achievementRateName}}<span>{{cardData.achievementRate}}</span>{{cardData.unit}}
          </p>
        </van-col>
    </van-row>
    <van-row type="flex" class="circleFooter">
      <van-col span="6">{{cardData.orgName}}</van-col>
      <van-col span="18" :style="{textAlign:'right'}">统计时间：{{cardData.yearTime}}</van-col>
    </van-row>
    <van-popup v-model="show"
    position="bottom"
    :style="{ height: '40%' }">
      <van-datetime-picker
        ref="picker"
        v-if="showFlag.path == '/performance/controlTime/getTime' && cardData.indexId !== 'D0104-1011'"
        v-model="currentDate"
        :type="showTime"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="cancel"
        @confirm="confirm"
      />
      <van-datetime-picker
        v-if="showFlag.path == '/performance/controlTime/getTime' && cardData.indexId === 'D0104-1011'"
        ref="picker"
        v-model="currentDate"
        :type="showTime"
        @cancel="cancel"
        @confirm="confirm"
        :filter="filter"
      />
    </van-popup>
  </div>
</template>

<script>
import { postAction, getAction } from '@/utils/api'
import { getCurrentMonthLast, getCurrentTime, getUrlKey } from '@/utils/util'
import Bus from '@/utils/bus'

export default {
  name: 'Record',
  data () {
    return {
      date: '',
      time: 2,
      daydate: '',
      show: false,
      cardData: {name: '--', indexValue: '--', orgName: '--'},
      showTime: 'year-month',
      minDate: '',
      maxDate: '',
      currentDate: new Date(),
      getUrl: '', //  获取url的indexId
      getUrl1: '', //  获取url的businessId
      getOrgId: '', //  获取url的orgId
      getLevel: '', //  获取url的level
      getPathId: '', //  关注调整条件
      getCareDesc: '', //  关注的描述
      getCode: '',
      showFlag: {},
      passTime: '',
      passTimeDate: '',
      range: [],
      menuIndex: '',
      quato: null
    }
  },
  methods: {
    getHeaderInfo (val) {
      var postData
      var url = '/simpapp/menu/menuIndexApi'
      this.getUrl = getUrlKey('indexId', window.location.href)
      this.getUrl1 = getUrlKey('businessId', window.location.href)
      if (this.getUrl && this.getUrl1) {
        postData = {
          'indexCode': this.getUrl,
          'pageCode': this.getUrl1,
          'date': this.date || '',
          'dateType': this.time
        }
      } else {
        postData = {
          'indexCode': this.$store.state.ope.quota,
          'pageCode': this.$store.state.ope.kind,
          'date': this.date || '',
          'dateType': this.time
        }
      }
      var obj = postAction(url, postData)
      obj.then((res) => {
        this.channelData = res.data.salechnl
        const tmpChannel = this.$store.state.ope.detailChannel
        Bus.$emit('channelData', this.channelData)
        for (var i = 0; i < this.channelData.length; i++) {
          if (tmpChannel === this.channelData[i].dataSalechnlCode) {
            this.$store.commit('REN_SET_DETAIL_CHANNEL', this.channelData[i].dataSalechnlCode)
            this.$store.commit('REN_SET_DETAIL_CHANNEL_NAME', this.channelData[i].salechnlName)
            return
          }
        }
      })
    },
    getHomeInfo () {
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode,
        indexId: this.$store.state.ope.quota,
        // channelId: this.$store.state.ope.channel,
        channelId: '0101',
        date: this.date || ''
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        this.showFlag = res.data
        this.getCardContent()
        // this.gitRange()
      })
    },
    getCardContent () {
      if (this.showFlag.indexMonth === 0 && this.showFlag.indexYear === 1) {
        this.time = 3
        this.$store.commit('OPE_SET_TIME', 3)
        this.$store.commit('OPE_SET_TIME_NAME', '年')
      }
      var url = '/performance/yeJiOperation/getIndexCard'
        // var url = '/simpapp/operation/getOrgAnalyListChild'
        //  从Android和iOS获取的url截取参数
      var postData = {
        'channelId': '0101',
        'classification': this.$store.state.ope.kind,
        'date': this.date || '',
        'dateType': this.time,
        'indexId': [this.$store.state.ope.quota],
        'level': this.$store.state.user.level,
        'orgId': this.$store.state.user.orgId
      }
      var obj = postAction(url, postData)
      obj.then(res => {
        if (res.code !== 0) {
          return ''
        } else {
        this.cardData = res.data
        this.$emit('year', this.cardData.yearTime.substr(0, 4))
        this.passTime = this.cardData.yearTime
        //  获取后重新赋值 传值
        this.$store.commit('OPE_SET_QUOTA', this.cardData.indexId)
        this.$store.commit('OPE_SET_QUOTA_NAME', this.cardData.name)
        localStorage.setItem('quotaname', this.cardData.name)
        // document.title = localStorage.getItem('quotaname')
        // 判断显示为null 渲染--
        if (this.cardData.indexValue === null) {
          this.cardData.indexValue = '--'
        }
        if (this.cardData.achievementRate === null) {
          this.cardData.achievementRate = '--'
        }
        if (this.cardData.onYearRate === null) {
          this.cardData.onYearRate = '--'
        }
        }
      })
    },
    // gitRange () {
    //   var timePost = {
    //     'dateType': this.time,
    //     'indexId': new Array(this.showFlag.indexCode),
    //     'classification': this.$store.state.ope.kind // 点击日历传入渠道指标code
    //   }
    //   this.showFlag.path = '/simpapp/controlTime/getTime'
    //   var timeObj = postAction(this.showFlag.path, timePost)
    //   timeObj.then(res => {
    //     this.range = res.data
    //     // this.currentDate = new Date(2022, 2, 2)
    //   })
    // },
    changeTime (index) {
      this.time = index
      this.getCurrentDate()
      // this.date = ''
      if (this.date === 'year-month') {
        this.date = ''
      }
      this.$emit('postDate', this.date, this.currentDate)
      this.$emit('year', this.date.substr(0, 4))
      this.$store.commit('OPE_SET_QUOTA', this.cardData.indexId)
      this.$store.commit('OPE_SET_TIME', index)
      if (index === 1) {
        this.$store.commit('OPE_SET_TIME_NAME', '日')
      } else if (index === 2) {
        this.$store.commit('OPE_SET_TIME_NAME', '月')
      } else {
        this.$store.commit('OPE_SET_TIME_NAME', '年')
        // 当日历切换至年并且不显示目标值的时候也就是只显示检测值，指标为电话回访率的情况下执行
        if (this.time === 3 && !this.cardData.targetShow) {
          // this.cardData.detectionShow = true
        } else {
          $('.ratevalue-warpper').css('display', 'none')
          $('.ratevalue-value span').css('marginLeft', '0rem')
        }
      }
      // 如果为true则切换为显示监测值，然后此时接口返回是false，就会出现切换指标闪现出现监测值然后消失的情况
      // this.cardData.detectionShow = true
      this.getHomeInfo()
    },
    // 获取默认进来日期
    getCurrentDate () {
      let yearTime = this.$store.state.ope.yearTime
      let monthTime = this.$store.state.ope.monthTime
      let currentDate = new Date()
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() + 1
      if (yearTime === currentYear) {
        this.currentYear1 = currentYear
      } else {
        this.currentYear1 = yearTime
      }
      if (monthTime === currentMonth) {
        this.currentMonth1 = currentMonth
      } else {
        this.currentMonth1 = monthTime
      }
      this.getLastDay(this.currentYear1, this.currentMonth1)
    },
    // 获取当月最后一天日期
    getLastDay (year, month) {
      let month1 = month
      let newYear = year // 取当前的年份
      var newMonth = month++ // 取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        newMonth -= 12 // 月份减
        newYear++ // 年份增
      }
      var newDate = new Date(newYear, newMonth, 1) // 取当年当月中的第一天
      let day1 = (new Date(newDate.getTime() - 1000 * 60 * 60 * 24)).getDate()
      this.currentDate = year + '-' + month1 + '-' + day1
      this.$store.commit('OPE_SET_CURRENT_TIME', this.currentDate)
      this.currentDate = new Date(this.currentDate)
      return (new Date(newDate.getTime() - 1000 * 60 * 60 * 24)).getDate() // 获取当月最后一天日期
    },
    // 通过传入filter函数，可以对选项数组进行过滤，实现自定义时间间隔
    filter (type, options) {
      if (this.range.length < 1) return []
      let currentDate = new Date(this.currentDate)
      let currentYear = currentDate.getFullYear()
      let currentMonth = currentDate.getMonth() + 1
      let item = this.range.find(_ => +_.year === currentYear)
      let year = item.startDate.substr(0, 4)
      let month = item.startDate.substring(4, 6)
      let day = item.startDate.substr(6)
      let startDate = year + '-' + month + '-' + day
      let startTime = new Date(startDate)
      let yearEnd = item.endDate.substr(0, 4)
      let monthEnd = item.endDate.substring(4, 6)
      let dayEnd = item.endDate.substr(6)
      let endDate = yearEnd + '-' + monthEnd + '-' + dayEnd
      let endTime = new Date(endDate)
      let months = [startTime.getMonth() + 1, endTime.getMonth() + 1]
      let days = [startTime.getDate(), endTime.getDate()]
      if (type === 'year') {
        return this.range.map(_ => _.year)
      } else if (type === 'month') {
        return options.filter(_ => {
          return +_ >= months[0] && +_ <= months[1]
        })
      } else if (type === 'day') {
        if (months[0] === months[1]) {
          return Array.apply(null, { length: 31 }).map((_, i) => {
            i += 1
            return i < 10 ? '0' + i : i + ''
          }).filter(_ => +_ >= days[0] && +_ <= days[1])
        }
        if (currentMonth === months[0]) {
          return options.filter(_ => +_ >= days[0])
        } else if (currentMonth === months[1]) {
          return options.filter(_ => +_ <= days[1])
        }
        return options
      }
    },
    showPopup () {
      var timePost = {
        'dateType': this.time,
        'indexId': new Array(this.showFlag.indexCode),
        'classification': this.$store.state.ope.kind // 点击日历传入渠道指标code
      }
      this.showFlag.path = '/performance/controlTime/getTime'
      var timeObj = postAction(this.showFlag.path, timePost)
      timeObj.then(res => {
        if (this.$store.state.ope.quota === 'D0104-1011') {
          this.timeShow = false
          res.data.sort((a, b) => {
            return +a.year > +b.year ? 1 : -1
          })
          this.range = res.data
          if (this.time === 2 || this.time === 3) {
            this.date = 'year-month'
          }
          if (this.showFlag.timeAccuracy === '1') {
            this.showTime = 'date'
          } else {
            this.showtime = 'year-month'
          }
          this.show = true
          return false
        }
        var timeStart = res.data.startDate.split('')
        if (timeStart.length < 8) {
          timeStart.splice(4, 0, '/')
          this.minDate = new Date(timeStart.join('').concat('/01'))
        } else {
          timeStart.splice(4, 0, '/')
          if (timeStart.length > 7) {
            timeStart.splice(7, 0, '/')
          }
          this.minDate = new Date(timeStart.join(''))
        }
        if (res.data.endDate) {
          var timeEnd = res.data.endDate.split('')
          timeEnd.splice(4, 0, '/')
          if (timeEnd.length > 7) {
            timeEnd.splice(7, 0, '/')
            this.maxDate = new Date(timeEnd.join(''))
          } else {
            this.maxDate = new Date(timeEnd.join('').concat('/01'))
          }
        } else {
          this.maxDate = new Date()
        }
        if (this.showFlag.timeAccuracy === '1') {
            this.showTime = 'date'
          } else {
            this.showtime = 'year-month'
          }
        this.show = true
      })
    },
    cancel () {
      if (this.date === 'year-month') {
        this.date = ''
      }
      this.show = false
    },
    confirm (date) {
      var curTime
      this.show = false
      this.currentDate = date
      curTime = getCurrentTime(new Date())
      if (getCurrentTime(this.currentDate) === curTime) {
          this.date = ''
      } else {
        this.date = getCurrentMonthLast(date)
      }
      this.$emit('postDate', this.date, this.currentDate)
      this.$emit('year', this.date.substr(0, 4))
      // 点击日历确定按钮 刷新导航头
      // this.getHeaderInfo(0)
      this.getHomeInfo()
    }
  },
  mounted () {
    this.quato = this.$store.state.user.pageCode
    this.$store.commit('OPE_SET_TIME', 2)
    this.$store.commit('OPE_SET_TIME_NAME', '月')
    this.getHomeInfo()
    // menuindex用于设置只在业务类型和案件范围在整体下切换至年显示目标值检测值
    Bus.$on('menuIndex', (val) => {
      this.menuIndex = val
    })
    this.getCurrentDate()
  },
  computed: {
    getChannel () {
      return this.$store.state.ope.detailChannel
    }
  },
  watch: {
    passTime (newvalue, oldvalue) { // 监听所选日期
      this.passTimeDate = newvalue
      this.passCurrentDate = this.currentDate
      localStorage.setItem('passTimeDate', this.passTimeDate) // 年月日日期
      localStorage.setItem('passCurrentDate', this.passCurrentDate) // 组件日期
    },
    getChannel () {
      this.$nextTick(() => {
        if (this.$store.state.ope.detailChannel) {
          // this.getHeaderInfo(0)
          this.getHomeInfo()
        }
      })
    },
    date () {
      this.$nextTick(() => {
        this.$store.commit('OPE_SET_CALENDAR', this.date)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.van-popup--center{
  width : 100%;
}
.circle p{
  color: #333;
  font-size: 0.12rem;
  line-height: 0.3rem;
}
.circle p span {
  display: inline-block;
  margin: 0px 5px;
  color: #333;
  font-size: 0.22rem;
  font-family: '微软雅黑'
}
.ratevalue-warpper{
  display: flex;
  justify-content: space-around;
}
.ratevalue-value-second img{
  height:.35rem;
  width: 1px;
  margin-top .1rem
}
.ratevalue-value p{
  text-align : center;
  color : #999;
}
.ratevalue-value span{
  font-size : 0.18rem;
}
.tiem-iconfont{
  float: right;
  padding-left: .12rem;
  color : #999;
}
.circleHeight {
  margin-top: 0.1rem;
  padding: 0px 15px 15px 15px;
  background: #fff;
}

.circleTitle {
  font-size: 0.18rem;
  font-weight: 600;
  line-height: 0.45rem;
}
.circleTitle .nameTitle {
  line-height: normal;
  margin-top: .08rem;
  width: 42.66666667%;
}
.circleTitle div:last-child {
  text-align: right;
}

.circleFooter {
  font-size: 0.12rem;
  color: #BDBDBD;
}

.buttonChange {
  font-size: 0;
  text-align: right;
}

.buttonChange button {
  height: 0.26rem;
  line-height: 0.26rem;
  border: none;
  margin: 0;
  font-size: 0;
  font-size: 0.14rem;
  padding: 0 15px;
  color: #39f;
  background: none;
  border: 1px solid #39f;
  border-radius: 0.02rem;
}

.timeButton button {
  border: 1px solid #F2F2F2;
  color: #999;
}

.buttonChange .choose {
  background: #3399FF;
  border: 1px solid #3399FF;
  color: #fff;
  border-radius: 0.02rem;
}
>>>.van-col--10 {
  width: 143px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/components/DetailCard.vue